/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const waterSourceJSON = async (): Promise<any> => {
  const waterSource = useJSONStore.getState().waterSource;
  const token = useUserStore.getState().userToken;
  const setWaterSource = useJSONStore.getState().setWaterSource;

  if (waterSource.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.waterSource}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setWaterSource(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default waterSourceJSON;
